module.exports = __webpack_public_path__ + "ethereum_coin.svg?7c19954628081bf6fd772fa0d0819547";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ethereum_coin.svg
// module id = 457
// module chunks = 2